import _slicedToArray from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import raf from "rc-util/es/raf";
export default function useRafLock() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var rafRef = React.useRef(null);
  var cleanup = function cleanup() {
    raf.cancel(rafRef.current);
  };
  var setDelayState = function setDelayState(nextState) {
    cleanup();
    if (nextState) {
      setState(nextState);
    } else {
      rafRef.current = raf(function () {
        setState(nextState);
      });
    }
  };
  React.useEffect(function () {
    return cleanup;
  }, []);
  return [state, setDelayState];
}